import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import "./styles/button.css";
import "./styles/typography.css";
import "./styles/spacing.css";
import Home from "./pages/home/home";
import AllProjects from "./pages/allProjects/allProjects";
import Project from "./pages/project/project";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "projects",
    element: <AllProjects />,
  },
  {
    path: "projects/:projectId",
    element: <Project />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
